<template>
    <div style="width: 100%;scroll-behavior: smooth;">
        <Header />
        <!-- <button @click="toHeight('four')">点击</button>
        <a href="#two" style="transition: all .5s ease-in;">tiaozhuan</a> -->
        <div class="content">
            <div class="one" id="one">
                <el-carousel :interval="5000" arrow="always" class="carousel">
                    <el-carousel-item
                        v-for="(item, index) in pictureList"
                        :key="index"
                    >
                        <img
                            :src="
                                downloadUrl +
                                item.qytp
                            "
                            alt=""
                            class="picture"
                            @click="pictureDetail(item)"
                        />
                    </el-carousel-item>
                </el-carousel>
                <div class="middle">
                    <div class="title">
                        <div class="desc">新闻动态</div>
                        <div class="more">MORE+</div>
                    </div>
                    <div class="list">
                        <div class="item" v-for="item in 6">
                            <div class="dot"></div>
                            <div class="list-title">链主"带动，培植未来!淄博高新区17家...</div>
                            <div class="time">2024-08-07</div>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="title">
                        <div class="desc">通知公告</div>
                        <div class="more">MORE+</div>
                    </div>
                    <div class="list">
                        <div class="item" v-for="item in 4">
                            <div class="time">
                                <div class="day">13</div>
                                <div class="date">2024-08</div>
                            </div>
                            <div class="list-title">淄博市新培养新引进正高级专技人才补贴人员公示</div>
                        </div>
                    </div>
                    <!-- <div v-if="messageTab == 1">
                        <div
                            class="list"
                            v-for="(item, index) in maocudongtaiList.slice(0, 9)"
                            :key="index"
                            @click="godetail(item)"
                        >
                            <div class="dian"></div>
                            <div class="name">{{ item.title }}</div>
                            <div class="time">
                                {{ item.releaseTime.split(" ")[0] }}
                            </div>
                        </div>
                    </div>
                    <div v-if="messageTab == 2">
                        <div
                            class="list"
                            v-for="(item, index) in huiyuanzhijiaList.slice(0, 9)"
                            :key="index"
                            @click="godetail(item)"
                        >
                            <div class="dian"></div>
                            <div class="name">{{ item.title }}</div>
                            <div class="time">
                                {{ item.releaseTime.split(" ")[0] }}
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="two" id="two">
                <!-- <ScrollItem></ScrollItem> -->
                <div class="title">
                    <div class="desc">快速指引</div>
                </div>
                <div class="list">
                    <div class="item" v-for="item in 8">
                        <div class="desc">人岗匹配</div>
                    </div>
                </div>
            </div>
            <div class="three">
                <div class="left">
                    <div class="title">
                        <div class="desc">政策法规</div>
                        <div class="more">MORE+</div>
                    </div>
                    <div class="list">
                        <div class="item" v-for="item in 6">
                            <div class="dot"></div>
                            <div class="list-title">链主"带动，培植未来!淄博高新区17家...</div>
                            <div class="time">2024-08-07</div>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="title">
                        <div class="desc">招聘信息</div>
                        <div class="more">MORE+</div>
                    </div>
                    <div class="list">
                        <div class="item" v-for="item in 6">
                            <div class="dot"></div>
                            <div class="list-title">链主"带动，培植未来!淄博高新区17家...</div>
                            <div class="time">2024-08-07</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="four" id="four">
                <div class="title">
                    <div class="desc">成果展示</div>
                </div>
                <div class="navigate">
                    <!-- <div class="item" @click="promote()">项目对接与推广</div>
                    <div class="item" @click="jingmaoqiatan()">经贸洽谈</div>
                    <div class="item" @click="duiwaimaoyi()">对外贸易</div>
                    <div class="item" @click="zhaoshangtouzi()">招商投资</div>
                    <div class="item" @click="shangshifuwu()">商事服务</div>
                    <div class="item" @click="dangwugongkai()">党务公开</div> -->
                    <ScrollItem></ScrollItem>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import Header from "./header.vue";
import Header from "./lianhetiHeader.vue";
import Vue from "vue";
import vueMiniPlayer from "vue-mini-player";
import "vue-mini-player/lib/vue-mini-player.css";
Vue.use(vueMiniPlayer);

import ScrollItem from "./lianhetiScrollItem.vue";

import { Server } from "@/server";
import { Link } from "element-ui";

export default {
    name: "zhuanyequn",
    data() {
        return {
            messageTab: 1, //1：贸促动态   2：会员之家
            maocudongtaiList: [], //公告的数组
            huiyuanzhijiaList: [], //新闻的数组
            companyList: [], // 优秀企业的数组
            policyList: [], // 政策法规的数组
            qyfcList: [], // 企业风采的数组
            sffwList: [], // 商法服务的数组
            kjfwList: [], // 跨境服务的数组
            gjllList: [], // 国际联络的数组
            tzcjList: [], // 投资促进的数组
            hzxxList: [], // 会展信息的数组
            pictureList: [], // 图片新闻的数组
            id: "",
            playArr: "name2",
            downloadUrl:'',

            articleList: []
        };
    },
    
    components: {
        ScrollItem,
        Header,
    },
    created() {
        // this.getList()
        // this.getPictureList()
    },
    
    methods: {
        getList() {
            Server.articleList({
                articleType: '建设动态',
                homePageType: '专业群'
            }).then(res => {
                console.log(res);
                
            })
        },
        getPictureList() {
            Server.pictureList({
                picturePosition: '轮播图',
                homePageType: '专业群'
            }).then(res => {
                console.log(res);
                if(res.code == 200) {
                    this.pictureList = res.result
                }
            })
        },
        godetail(item) {
            this.$router.push({
                path: "/noticedetail",
                query: {
                    messageTab: this.messageTab,
                    type: item.type,
                    id: item.id,
                },
            });
        },
        //贸促动态，会员之家查看更多
        more() {
            this.$router.push({
                path: "/notice",
                query: { messageTab: this.messageTab },
            });
        },
        //贸促动态
        getmcdt() {
            Server.infoList({
                type: 1,
                status: 1,
                pageSize: 10,
                pageNo: 1,
            }).then((res) => {
                console.log(res);
                if (res.code == 200) {
                    this.maocudongtaiList = res.result.records;
                    // this.handleTime();
                }
            });
        },

        toHeight(toEl) {
            // toEl 为指定跳转到该位置的DOM节点
            toEl = document.querySelector('#four')
            let bridge = toEl;
            let body = document.body;
            let height = 0;
            
            // 计算该 DOM 节点到 body 顶部距离
            do {
            height += bridge.offsetTop;
            bridge = bridge.offsetParent;
            } while (bridge !== body)

            window.scrollTo({
                top: height,
                behavior: 'smooth'
            })
        },
        handleFullscreen() {},
    },

    mounted() {
        //获取贸促动态
        // this.getmcdt();
        
        // this.$store.state.CommonHeader.tab = 0;
        // this.imgList = [];
        // this.downloadUrl = this.$downloadUrl
    },
};
</script>

<style lang="less" scoped>
// body, html {
//     scroll-behavior: smooth;
// }
.content {
width: 70%;
margin: 20px auto 0;
// padding: 0 30px;


    .header-banner {
        width: 100%;
        height: 336px;
    }
    .one {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .carousel {
            width: 32%;
            height: 350px;
            // padding: 20px;
            box-sizing: border-box;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            // justify-content: center;
            .picture {
                width: 100%;
                height: 350px;
            }
            .el-carousel__item {
                width: 100%;
                height: 350px;
            }
            .el-carousel__item h3 {
                width: 600px;
                height: 100%;
                color: #475669;
                opacity: 0.75;
                line-height: 310px;
                margin: 0;
                text-align: center;
            }
            .el-carousel__item:nth-child(2n) {
                background-color: #99a9bf;
            }

            .el-carousel__item:nth-child(2n + 1) {
                background-color: #d3dce6;
            }

            .el-carousel__indicator--horizontal {
                padding: 12px 7px;
            }
            ::v-deep .el-carousel__button {
                width: 7px !important;
                height: 7px !important;
                border-radius: 50%;
            }
        }
        
        .middle {
            width: 32%;
            height: 350px;
            background-color: #fff;

            padding: 10px 0;
            box-sizing: border-box;
            .title {
                padding: 0 15px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 30px;
                border-bottom: 1px solid #f3f1f4;
                .desc {
                    height: 100%;
                    line-height: 28px;
                    font-weight: bold;
                    border-bottom: 2px solid #0527AF;
                }
                .more {
                    color: #c6c6c6;
                    font-size: 15px;
                }
            }

            .list {
                width: 90%;
                margin: 15px auto 0;
                .item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    font-size: 14px;

                    margin: 10px 0;
                    .dot {
                        width: 4px;
                        height: 4px;
                        background-color: #0527AF;
                    }
                    .list-title {
                        color: #394F65;
                        
                        flex: 1;
                        margin: 0 10px 0 5px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .time {
                        color: #999;
                    }
                }
            }
        }

        .right {
            width: 32%;
            height: 350px;
            background-color: #fff;

            padding: 10px 0;
            box-sizing: border-box;
            // margin-right: 40px;
            .title {
                padding: 0 15px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 30px;
                border-bottom: 1px solid #f3f1f4;
                .desc {
                    height: 100%;
                    line-height: 28px;
                    font-weight: bold;
                    border-bottom: 2px solid #0527AF;
                }
                .more {
                    color: #c6c6c6;
                    font-size: 15px;
                }
            }
            .list {
                width: 90%;
                margin: 15px auto 0;
                
                .item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    cursor: pointer;

                    margin: 10px 0;
                    .time {
                        // width: 170px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-size: 13px;
                        color: #f5f5f5;
                        width: 50px;
                        height: 50px;
                        background-color: #919191;
                        .day {
                            font-weight: bold;
                            font-size: 18px;
                        }
                        .date {
                            margin-top: 5px;
                            font-size: 10px;
                        }
                    }
                    .list-title {
                        flex: 1;
                        margin-left: 10px;
                        font-size: 14px;
                        color: #394F65;
                        line-height: 20px;
                    }
                }
            }
        }
        
    }
    .two {
        // width: 1120px;
        padding: 10px 0;
        margin-top: 20px;
        box-sizing: border-box;
        background-color: #fff;
        .title {
            border-bottom: 1px solid #f3f1f4;
            padding: 0 20px;
            box-sizing: border-box;
            height: 30px;
            display: flex;
            .desc {
                height: 100%;
                line-height: 28px;
                font-weight: bold;
                border-bottom: 2px solid #0527AF;
            }
        }
        .list {
            width: 90%;
            margin: 15px auto 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            .item {
                width: 22%;
                height: 40px;
                background-color: #D7DFFF;
                color: #0527AF;
                display: flex;
                justify-content: center;
                align-items: center;

                border: 1px dashed #0527AF;
                margin-bottom: 15px;
            }
        }
    }
    .three {
        width: 100%;
        margin-top: 20px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
            padding: 0 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 30px;
            border-bottom: 1px solid #f3f1f4;
            .desc {
                height: 100%;
                line-height: 28px;
                font-weight: bold;
                border-bottom: 2px solid #0527AF;
            }
            .more {
                color: #c6c6c6;
                font-size: 15px;
            }
        }
        .left, .right {
            width: 49%;
            padding: 20px 0;
            box-sizing: border-box;
            background-color: #fff;
        }
        .list {
            width: 90%;
            margin: 15px auto 0;
            .item {
                display: flex;
                justify-content: space-between;
                align-items: center;

                font-size: 14px;

                margin: 10px 0;
                .dot {
                    width: 4px;
                    height: 4px;
                    background-color: #0527AF;
                }
                .list-title {
                    color: #394F65;
                    
                    flex: 1;
                    margin: 0 10px 0 5px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .time {
                    color: #999;
                }
            }
        }
    }
    .four {
        width: 100%;

        padding: 10px 0;
        margin-top: 20px;
        box-sizing: border-box;
        background-color: #fff;

        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        .title {
            padding: 0 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 30px;
            border-bottom: 1px solid #f3f1f4;
            .desc {
                height: 100%;
                line-height: 28px;
                font-weight: bold;
                border-bottom: 2px solid #0527AF;
            }
            .more {
                color: #c6c6c6;
                font-size: 15px;
            }
        }
        .navigate {
            width: 1090px;
            // height: 140px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            margin: 10px auto 20px;
            cursor: pointer;
        }
    }
    
}
:deep(.el-carousel__arrow.el-carousel__arrow--left) {
    display: none;
}
:deep(.el-carousel__arrow.el-carousel__arrow--right) {
    display: none;
}

/* pad */
@media screen and (max-width: 1199px) and (min-width: 600px) {
    .content {
        .two {
            .img {
                padding: 0;
                .img {
                    width: 330px;
                    height: 130px;
                    cursor: pointer;
                    padding: 0;
                }
            }
        }
        .three {
            .con {
                .div {
                    .img {
                        width: 300px;
                        height: 226px;
                    }
                }
            }
        }
    }
}


:deep(.el-carousel__indicators--horizontal) {
    position: relative;
    // top: 15px;
    text-align: center;
}
</style>
